import React, { useEffect } from 'react'
import Navbar from '../landing/header/Navbar'
import './buttonComponent.scss'

function Executed(props) {

    useEffect(() => {
        window.scrollTo(0, 0)
      }, [])

    return (
        <>
            <Navbar />
            <section className='banner-main banner-main ptb executed-main'>
                <div className="container-fluid p-0">
                    <div className="row">
                        <div className="col-xl-11 col-lg-11 m-auto ">
                            <div className="pioneerDao">
                                <div className="governancebox topBtnsDiv usvtcvtvscvt">
                                    <div className="d-flex  align-items-center justify-content-between flex-wrap">
                                        <h3 className='heading-text'>Proposal 14</h3>
                                        <button className='exii' data-toggle="modal" data-target="#exampleModalvote">Executed</button>
                                    </div>
                                    <p>Voting ended november 14, 2022 4:01 PM EDT</p>
                                    <p>This proposal has reached quorium (8 votes) </p>
                                </div>
                                {/* <div className="governance-another">
                                <div className="d-flex  align-items-center">
                                        <h3 className='suvsguvcuvvsc'>Proposal 140</h3>
                                        <button className='exii'>Executed</button>
                                        <button className='active-green'>Active</button>
                                    </div>
                                    <h6>Pilot: Crowdsourced Prop House</h6>
                                    <p>Proposed by  <span>0x47...c7e9  at 0x314ce</span></p>
                                </div> */}
                            </div>

                            <div className="right-content">
                                <div className="twice">
                                    <p>you have no votes</p>
                                    <button className='btn-submit-disable'>Submit Proposal</button>
                                </div>
                            </div>

                            <div className="countSection">


                                <div className="row">
                                    <div className="col-md-4 pl-md-0">
                                        <div className="forAganist">
                                            <p>FOR</p>
                                            <h3>25</h3>
                                        </div>
                                    </div>
                                    <div className="col-md-4">
                                        <div className="forAganist">
                                            <p className='text-danger'>Against</p>
                                            <h3>0</h3>
                                        </div>
                                    </div>
                                    <div className="col-md-4 pr-md-0">
                                        <div className="forAganist">
                                            <p className='text-secondary'>Abstain</p>
                                            <h3>2</h3>
                                        </div>
                                    </div>
                                    <div className="col-md-4 pl-md-0">
                                        <div className="ThresholdDiv">
                                            <p>Threshold</p>
                                            <div >
                                                <h6>Quorum</h6>
                                                <p className='qutoa'>36 Votes</p>
                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 ">
                                        <div className="ThresholdDiv">
                                            <p>Ended</p>
                                            <div >
                                                <h6>2:05 PM GMT+5</h6>
                                                <p className='qutoa'>July 10, 2022</p>

                                            </div>
                                        </div>
                                    </div>
                                    <div className="col-md-4 pr-md-0">
                                        <div className="ThresholdDiv">
                                            <p>Snapshot</p>
                                            <div >
                                                <h6>Taken at block</h6>
                                                <p className='qutoa'>15080360</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            </div>
                            <div className="pioneerDao">
                                <div className="governancebox topBtnsDiv descriptiondd">
                                    <h3>Description</h3>

                                    <p>At vero eos et accusamus et iusto odio dignissimos ducimus qui blanditiis praesentium voluptatum deleniti atque corrupti quos dolores et quas molestias excepturi sint occaecati.
                                        Et harum quidem rerum facilis est et expedita distinctio.
                                    </p>
                                    <p className='mt-4'>Nam libero tempore, cum soluta nobis est eligendi optio cumque nihil impedit quo minus id quod maxime placeat facere possimus, omnis voluptas assumenda est, omnis dolor repellendus.</p>
                                </div>
                            </div>

                        </div>
                    </div>

                </div>
               
                <div className='vote'>
                    <div class="modal fade" id="exampleModalvote" tabindex="-1" role="dialog" aria-labelledby="exampleModalLabel" aria-hidden="true">
                        <div class="modal-dialog modal-dialog-centered" role="document">
                            <div class="modal-content">

                                <div class="modal-body">
                                    <div className='main-heading'>
                                        <h3>Confirm Transacton</h3>
                                        <a type="button" class="close" data-dismiss="modal" aria-label="Close">
                                            <img src='\assets\cross-btn.svg' className='img-fluid crossimg' />
                                        </a>


                                    </div>
                                    <div className='vote-btn'>
                                        <button className='votefor' >Vote For</button>
                                        <button className='voteagainst' >Vote Against</button>
                                        <button className='voteabstain' >Vote Abstain</button>
                                    </div>
                                    <div className='confirmbtn'>
                                        <button className="" >Submit Vote</button>
                                    </div>
                                </div>

                            </div>
                        </div>
                    </div>
                </div>
            </section>
        </>
    )
}

export default Executed